export default "__VITE_ASSET__CVxpYl$X__"